// Ordered by day-to-day priority/frequency of use rather than build order:
// Dashboard and Orders are fixed at the top (glance at stats, then act on
// orders — the two things opened constantly). Delivery Management and Store
// Management follow as the other daily operational tasks (assigning riders,
// toggling store/menu availability). Reports and Marketing are checked
// often but aren't minute-to-minute. Masters/Administration are
// setup-and-forget configuration, touched rarely after onboarding.
// Developer tools are dev-only and used least, so they sit last.
const SidebarData = [
  // ─── Dashboard ───────────────────────────────────────────────
  {
    label: "Menu",
    isMainMenu: true,
  },
  {
    label: "Dashboard",
    icon: "mdi mdi-home-variant-outline",
    url: "/dashboard",
    isHasArrow: true,
    bgcolor: "bg-primary",
  },


  // ─── Orders ──────────────────────────────────────────────────
  {
    label: "Orders",
    isMainMenu: true,
  },

  {
    label: "Orders",
    icon: "mdi mdi-basket-outline",
    subItem: [
      { sublabel: "All Orders", link: "/Orders" },
      { sublabel: "Live Orders", link: "/Orders/live" },
    ],
  },

  // ─── Delivery Management ─────────────────────────────────────
  {
    label: "Delivery Management",
    isMainMenu: true,
  },

  {
    label: "Delivery Management",
    icon: "mdi mdi-truck-delivery",
    subItem: [
      { sublabel: "Delivery Riders", link: "/Delivery" },
      { sublabel: "Rider Availability", link: "/Delivery/Availability" },
      { sublabel: "Delivery History", link: "/Delivery/History" },
    ],
  },

  // ─── Store Management ─────────────────────────────────────────
  {
    label: "Store Management",
    isMainMenu: true,
  },
  {
    label: "Store Management",
    icon: "mdi mdi-store-outline",
    subItem: [
      { sublabel: "Store Menu", link: "/store/menu" },
      { sublabel: "Delivery Settings", link: "/settings/delivery-settings" },
    ],
  },

  // ─── Reports ──────────────────────────────────────────────────
  {
    label: "Reports",
    isMainMenu: true,
  },
  {
    label: "Reports",
    icon: "mdi mdi-chart-bar",
    subItem: [
      { sublabel: "Daily Sales", link: "/reports/daily-sales" },
      { sublabel: "Store Sales", link: "/reports/store-sales" },
      { sublabel: "Best Sellers", link: "/reports/best-sellers" },
      { sublabel: "Delivery Report", link: "/reports/delivery" },
      { sublabel: "Promotion Report", link: "/reports/promotion" },
    ],
  },

  // ─── Marketing ───────────────────────────────────────────────
  // Promotions and Banners were one combined "Marketing" menu item, which
  // meant they could only be hidden/shown together. Split so a store admin
  // (who can manage their own store's promotions but not the platform-wide
  // homepage banners) can see one without the other — see
  // Sidebar.js's SUPERADMIN_ONLY_LABELS.
  {
    label: "Marketing",
    isMainMenu: true,
  },
  {
    label: "Promotions",
    icon: "mdi mdi-bullhorn-outline",
    subItem: [
      { sublabel: "Promotions", link: "/promotions" },
    ],
  },
  {
    label: "Banners",
    icon: "mdi mdi-image-outline",
    subItem: [
      { sublabel: "Banners", link: "/banners" },
    ],
  },

  // ─── Masters ─────────────────────────────────────────────────
  {
    label: "Masters",
    isMainMenu: true,
  },



  {
    label: "Masters",
    icon: "mdi mdi-book-open-page-variant-outline",
    subItem: [
      { sublabel: "Categories", link: "/Category" },
      { sublabel: "Variant Types", link: "/variants" },
      { sublabel: "Cities", link: "/cities" },
      { sublabel: "Stores", link: "/stores" },
      { sublabel: "Product Catalog", link: "/catalog/products" },
      { sublabel: "App Settings", link: "/app-settings" },
    ],
  },

  // ─── Administration ──────────────────────────────────────────
  {
    label: "Administration",
    isMainMenu: true,
  },
  {
    label: "Administration",
    icon: "mdi mdi-shield-account-outline",
    subItem: [
      { sublabel: "Users", link: "/users" },
      { sublabel: "Payments", link: "/payments" },
      { sublabel: "Settings", link: "/admin-settings" },
    ],
  },

  // ─── Developer ───────────────────────────────────────────────
  {
    label: "Developer",
    isMainMenu: true,
  },
  {
    label: "Developer",
    icon: "mdi mdi-code-braces",
    subItem: [
      { sublabel: "Promotion Playground", link: "/developer-tools/promotion-playground" },
      { sublabel: "Location Playground", link: "/developer-tools/location-playground" },
      { sublabel: "Delivery Playground", link: "/developer-tools/delivery-playground" },
      { sublabel: "Customer Session", link: "/developer-tools/customer-session" },
      { sublabel: "Order Lifecycle Simulator", link: "/developer-tools/order-playground" },
    ],
  },

  //   {
  //     label: "Calendar",
  //     icon: "mdi mdi-calendar-outline",
  //     isHasArrow: true,
  //     url: "/#",
  //   },
  //   {
  //     label: "Email",
  //     icon: "mdi mdi-email-outline",
  //     subItem: [
  //       { sublabel: "Inbox", link: "/#" },
  //       { sublabel: "Read Email", link: "/#" },
  //       { sublabel: "Email Compose", link: "/#l" },
  //     ],
  //   },
  //   {
  //     label: "Pages",
  //     isMainMenu: true,
  //   },
  //   {
  //     label: "Authentication",
  //     icon: "mdi mdi-account-circle-outline",
  //     subItem: [
  //       { sublabel: "Login", link: "/#" },
  //       { sublabel: "Register", link: "/#" },
  //       { sublabel: "Recover Password", link: "/#" },
  //       { sublabel: "Lock Screen", link: "/#" },
  //     ],
  //   },
  //   {
  //     label: "Utility",
  //     icon: "mdi mdi-format-page-break",
  //     subItem: [
  //       { sublabel: "Starter Page", link: "/#" },
  //       { sublabel: "Maintenance", link: "/#" },
  //       { sublabel: "Coming Soon", link: "/#" },
  //       { sublabel: "Timeline", link: "/#" },
  //       { sublabel: "FAQs", link: "/#" },
  //       { sublabel: "Pricing", link: "/#" },
  //       { sublabel: "Error 404", link: "/#" },
  //       { sublabel: "Error 500", link: "/#" },
  //     ],
  //   },
  //   {
  //     label: "Components",
  //     isMainMenu: true,
  //   },
  //   {
  //     label: "UI Elements",
  //     icon: "mdi mdi-briefcase-variant-outline",
  //     subItem: [
  //       { sublabel: "Alerts", link: "/#" },
  //       { sublabel: "Badge", link: "/#" },
  //       { sublabel: "Breadcrumb", link: "/#" },
  //       { sublabel: "Buttons", link: "/#" },
  //       { sublabel: "Cards", link: "/#" },
  //       { sublabel: "Carousel", link: "/#" },
  //       { sublabel: "Dropdowns", link: "/#" },
  //       { sublabel: "Grid", link: "/#" },
  //       { sublabel: "Images", link: "/#" },
  //       { sublabel: "Lightbox", link: "/#" },
  //       { sublabel: "Modals", link: "/#" },
  //       { sublabel: "Offcanvas", link: "/#" },
  //       { sublabel: "Range Slider", link: "/#" },
  //       { sublabel: "Session Timeout", link: "/#" },
  //       { sublabel: "Pagination", link: "/#" },
  //       { sublabel: "Progress Bars", link: "/#" },
  //       { sublabel: "Placeholders", link: "/#" },
  //       { sublabel: "Tabs & Accordions", link: "/#" },
  //       { sublabel: "Typography", link: "/#" },
  //       { sublabel: "Toasts", link: "/#" },
  //       { sublabel: "Video", link: "/#" },
  //       { sublabel: "Popovers & Tooltips", link: "/#" },
  //       { sublabel: "Rating", link: "/#" },
  //     ],
  //   },
  //   {
  //     label: "Forms",
  //     icon: "ri-eraser-fill",
  //     issubMenubadge: true,
  //     bgcolor: "bg-danger",
  //     badgeValue: "8",
  //     subItem: [
  //       { sublabel: "Form Elements", link: "/#" },
  //       { sublabel: "Form Validation", link: "/#" },
  //       { sublabel: "Form Advanced Plugins", link: "/#" },
  //       { sublabel: "Form Editor", link: "/#" },
  //       { sublabel: "Form File Upload", link: "/#" },
  //       { sublabel: "Form X-editable", link: "/#" },
  //       { sublabel: "Form Wizard", link: "/#" },
  //       { sublabel: "Form Mask", link: "/#" },
  //     ],
  //   },
  //   {
  //     label: "Tables",
  //     icon: "ri-table-2",
  //     subItem: [
  //       { sublabel: "Basic Tables", link: "/#" },
  //       { sublabel: "List Js", link: "/#" },
  //       { sublabel: "React Datatables", link: "/#" },
  //     ],
  //   },
  //   {
  //     label: "Charts",
  //     icon: "ri-bar-chart-line",
  //     subItem: [
  //       { sublabel: "Apex Charts", link: "/#" },
  //       { sublabel: "Chartjs Charts", link: "/#" },
  //       { sublabel: "Re Charts", link: "/#" },
  //       { sublabel: "Knob Charts", link: "/#" },
  //       { sublabel: "Sparkline Charts", link: "/#" },
  //     ],
  //   },
  //   {
  //     label: "Icons",
  //     icon: "ri-brush-line",
  //     subItem: [
  //       { sublabel: "Box Icons", link: "/#" },
  //       { sublabel: "Material Design", link: "/#" },
  //       { sublabel: "Dripicons", link: "/#" },
  //       { sublabel: "Font Awesome", link: "/#" },
  //     ],
  //   },
  //   {
  //     label: "Maps",
  //     icon: "ri-map-pin-line",
  //     subItem: [
  //       { sublabel: "Google Maps", link: "/#" },
  //       { sublabel: "Vector Maps", link: "/#" },
  //     ],
  //   },
  //   {
  //     label: "Multi Level",
  //     icon: "ri-share-line",
  //     subItem: [
  //       { sublabel: "Level 1.1", link: "/#" },
  //       {
  //         sublabel: "Level 1.2",
  //         link: "/#",
  //         subMenu: [{ title: "Level 2.1" }, { title: "Level 2.2" }],
  //       },
  //     ],
  //   },
];
export default SidebarData;
